import React from 'react';
import { motion } from 'framer-motion';
import { useModal } from '../services/ModalService';
import '../styles/pages/SoftwareDevelopment.css';

const SoftwareDevelopment = () => {
  const { openContactModal } = useModal();

  return (
    <div className="software-page">
      {/* Hero Section */}
      <section className="software-hero">
        <div className="software-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ textAlign: "center" }}
          >
            <div className="hero-badge">
              💻 Custom Software Solutions
            </div>
            
            <h1 className="hero-title"
            dangerouslySetInnerHTML={{ __html: "Expert <span class=\"gradient-text\">Software Development</span><br />Services" }}
            />
            
            <p className="hero-subtitle">
              Transform your business with custom software solutions. Our experienced development team delivers scalable, secure, and user-friendly applications tailored to your specific needs.
            </p>
            
            <div className="hero-buttons">
              <button 
                className="btn-primary"
                onClick={() => openContactModal(
                  'Software Development Services',
                  'Software Development Page - Get Started Today'
                )}
              >
                Get Started Today
              </button>
              <button 
                className="btn-secondary"
                onClick={() => openContactModal(
                  'Software Development Information',
                  'Software Development Page - Learn More'
                )}
              >
                Learn More
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Services Section */}
      <section className="software-section">
        <div className="software-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h2 className="software-section-title gradient-text">Our Software Development Services</h2>
            <p className="software-section-subtitle">
              Comprehensive solutions tailored to meet your specific business needs with cutting-edge technology
            </p>
            
            <div style={{ 
              display: "grid", 
              gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))", 
              gap: "30px", 
              marginTop: "60px" 
            }}>
              
              <div className="software-glass-card">
                <h3 style={{ color: "#8B5CF6", marginBottom: "20px", fontSize: "1.5rem" }}>Web Application Development</h3>
                <p style={{ marginBottom: "20px", lineHeight: "1.6" }}>Modern, responsive web applications built with cutting-edge technologies and frameworks.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ React/Angular/Vue.js Frontend</li>
                  <li style={{ marginBottom: "8px" }}>✓ Node.js/Python/Java Backend</li>
                  <li style={{ marginBottom: "8px" }}>✓ Progressive Web Apps (PWA)</li>
                  <li style={{ marginBottom: "8px" }}>✓ RESTful API Development</li>
                </ul>
              </div>
              
              <div className="software-glass-card">
                <h3 style={{ color: "#8B5CF6", marginBottom: "20px", fontSize: "1.5rem" }}>Mobile App Development</h3>
                <p style={{ marginBottom: "20px", lineHeight: "1.6" }}>Native and cross-platform mobile applications for iOS and Android platforms.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ React Native Development</li>
                  <li style={{ marginBottom: "8px" }}>✓ Flutter Cross-Platform</li>
                  <li style={{ marginBottom: "8px" }}>✓ Native iOS Development</li>
                  <li style={{ marginBottom: "8px" }}>✓ Native Android Development</li>
                </ul>
              </div>
              
              <div className="software-glass-card">
                <h3 style={{ color: "#8B5CF6", marginBottom: "20px", fontSize: "1.5rem" }}>Enterprise Software</h3>
                <p style={{ marginBottom: "20px", lineHeight: "1.6" }}>Scalable enterprise solutions designed to streamline business operations and workflows.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ Enterprise Resource Planning</li>
                  <li style={{ marginBottom: "8px" }}>✓ Customer Relationship Management</li>
                  <li style={{ marginBottom: "8px" }}>✓ Business Process Automation</li>
                  <li style={{ marginBottom: "8px" }}>✓ Legacy System Integration</li>
                </ul>
              </div>
              
              <div className="software-glass-card">
                <h3 style={{ color: "#8B5CF6", marginBottom: "20px", fontSize: "1.5rem" }}>E-commerce Platforms</h3>
                <p style={{ marginBottom: "20px", lineHeight: "1.6" }}>Complete e-commerce solutions with payment integration and inventory management.</p>
                <ul style={{ listStyle: "none", padding: 0, color: "#666" }}>
                  <li style={{ marginBottom: "8px" }}>✓ Custom Online Stores</li>
                  <li style={{ marginBottom: "8px" }}>✓ Payment Gateway Integration</li>
                  <li style={{ marginBottom: "8px" }}>✓ Inventory Management Systems</li>
                  <li style={{ marginBottom: "8px" }}>✓ Analytics & Reporting Dashboard</li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="software-section">
        <div className="software-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <h2 className="software-section-title gradient-text">Why Choose Our Development Services</h2>
            <p className="software-section-subtitle">
              Experience the advantages of working with our expert development team
            </p>
            
            <div style={{ 
              display: "grid", 
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", 
              gap: "30px",
              marginTop: "60px"
            }}>
              
              <div className="software-glass-card" style={{ textAlign: "center" }}>
                <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>🚀</div>
                <h4 style={{ color: "#8B5CF6", marginBottom: "10px", fontSize: "1.2rem" }}>Faster Time to Market</h4>
                <p style={{ color: "#666", lineHeight: "1.5" }}>Agile development practices ensure rapid delivery and quick iterations</p>
              </div>
              
              <div className="software-glass-card" style={{ textAlign: "center" }}>
                <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>🔧</div>
                <h4 style={{ color: "#8B5CF6", marginBottom: "10px", fontSize: "1.2rem" }}>Scalable Architecture</h4>
                <p style={{ color: "#666", lineHeight: "1.5" }}>Build solutions that grow with your business requirements</p>
              </div>
              
              <div className="software-glass-card" style={{ textAlign: "center" }}>
                <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>🛡️</div>
                <h4 style={{ color: "#8B5CF6", marginBottom: "10px", fontSize: "1.2rem" }}>Quality First</h4>
                <p style={{ color: "#666", lineHeight: "1.5" }}>Industry-standard quality practices integrated throughout development</p>
              </div>
              
              <div className="software-glass-card" style={{ textAlign: "center" }}>
                <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>📱</div>
                <h4 style={{ color: "#8B5CF6", marginBottom: "10px", fontSize: "1.2rem" }}>Cross-Platform</h4>
                <p style={{ color: "#666", lineHeight: "1.5" }}>Solutions that work seamlessly across all devices and platforms</p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="software-section">
        <div className="software-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="software-cta-card">
              <h3 style={{ 
                fontSize: "2rem", 
                marginBottom: "20px", 
                color: "#8B5CF6" 
              }}>
                Ready to Build Your Software Solution?
              </h3>
              <p style={{ 
                fontSize: "1.1rem", 
                marginBottom: "30px", 
                color: "#666",
                maxWidth: "600px",
                margin: "0 auto 30px"
              }}>
                Contact us today to learn how our custom software development services can transform your business operations and accelerate growth.
              </p>
              <div style={{ display: "flex", gap: "20px", justifyContent: "center", flexWrap: "wrap" }}>
                <button 
                  className="btn-primary"
                  onClick={() => openContactModal(
                    'Software Development Project',
                    'Software Development Page - Start Your Project'
                  )}
                >
                  Start Your Project
                </button>
                <button 
                  className="btn-secondary"
                  onClick={() => openContactModal(
                    'Software Development Consultation',
                    'Software Development Page - Schedule Consultation'
                  )}
                >
                  Schedule Consultation
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default SoftwareDevelopment;
